import { Link } from '@tanstack/react-router';
import type { AdminMeetingTemplateDto } from '@upme/contracts';
import { Badge } from '@upme/ui/components/badge';
import { Button } from '@upme/ui/components/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@upme/ui/components/table';
import { EmptyState } from '../../../shared/components/empty-state';
import { useAuth } from '../../auth/auth-context';
import { DeleteMeetingTemplateDialog } from './delete-meeting-template-dialog';

interface Props {
  templates: ReadonlyArray<AdminMeetingTemplateDto>;
}

export function MeetingTemplatesTable({ templates }: Props) {
  const { adminRoles } = useAuth();
  const isSuperadmin = adminRoles.includes('SUPERADMIN');

  if (templates.length === 0) {
    return (
      <EmptyState
        title="Шаблонов пока нет"
        description="Создайте первый шаблон встречи."
        cta={
          <Button asChild>
            <Link to="/meeting-templates/new">Создать шаблон</Link>
          </Button>
        }
      />
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-12">Эмодзи</TableHead>
          <TableHead>Название</TableHead>
          <TableHead>Время</TableHead>
          <TableHead>Длительность</TableHead>
          <TableHead>Порядок</TableHead>
          <TableHead>Доступность</TableHead>
          <TableHead>Статус</TableHead>
          <TableHead className="text-right">Действия</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {templates.map((t) => (
          <TableRow key={t.id}>
            <TableCell className="text-lg">{t.emoji}</TableCell>
            <TableCell>
              <Link
                to="/meeting-templates/$templateId"
                params={{ templateId: t.id }}
                className="hover:underline"
              >
                {t.title}
              </Link>
            </TableCell>
            <TableCell>{t.defaultTime ?? '—'}</TableCell>
            <TableCell>{t.defaultDurationMinutes ? `${t.defaultDurationMinutes} мин` : '—'}</TableCell>
            <TableCell>{t.sortOrder}</TableCell>
            <TableCell>{t.allCities ? 'Все города' : `Городов: ${t.cityIds.length}`}</TableCell>
            <TableCell>
              {t.isActive ? (
                <Badge variant="default">active</Badge>
              ) : (
                <Badge variant="secondary">inactive</Badge>
              )}
            </TableCell>
            <TableCell className="text-right">
              <div className="flex justify-end gap-1">
                <Button asChild variant="ghost" size="sm">
                  <Link to="/meeting-templates/$templateId" params={{ templateId: t.id }}>
                    Изменить
                  </Link>
                </Button>
                {isSuperadmin && <DeleteMeetingTemplateDialog template={t} />}
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
